import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	header: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	description: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	descriptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	header: {
		id: 'projects-directory-v3.page-layout.error-state.header',
		defaultMessage: 'An error occurred',
		description: '',
	},
	description: {
		id: 'projects-directory-v3.page-layout.error-state.description',
		defaultMessage:
			'There was a problem loading your projects. Try again or contact your administrator for support.',
		description: '',
	},
	descriptionGalaxia: {
		id: 'projects-directory-v3.page-layout.error-state.description-galaxia',
		defaultMessage:
			'There was a problem loading your spaces. Try again or contact your administrator for support.',
		description: '',
	},
});
export default messages;
